import React from 'react';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent, timelineItemClasses } from '@mui/lab';

export default function ReportsTimeline({ reportIconData, title = 'Your Reports', date = 'on Dec 19, 2025', onAddReport, totalReports }) {
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8 flex flex-col max-w-[340px] w-full mx-auto h-[450px]">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-lg font-bold text-slate-800">{title}</h3>
          {typeof totalReports === 'number' && (
            <p className="text-[11px] text-gray-500 mt-0.5">{totalReports} reports{date ? ` on ${date.replace(/^on /, '')}` : ''}</p>
          )}
        </div>
        {onAddReport && (
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded-xl font-semibold shadow hover:bg-blue-700 transition"
            onClick={onAddReport}
          >
            Add Report +
          </button>
        )}
      </div>
      <div className="relative flex-1 overflow-y-auto">
        <Timeline sx={{[`& .${timelineItemClasses.root}:before`]: {flex: 0,padding: 0,marginLeft: -2,},}}>
          {reportIconData.map((report, idx) => (
            <TimelineItem key={report.id} sx={{ minHeight: 0, py: 0.5 }}>
              <TimelineSeparator>
                <TimelineDot variant="outlined" sx={{ bgcolor: report.bg, borderColor: report.bg, color: report.bg }}/>
                {idx < reportIconData.length - 1 && <TimelineConnector sx={{ bgcolor: '#e6ecf3', minHeight: 16 }} />}
              </TimelineSeparator>
              <TimelineContent sx={{ py: 0, ml: 1 }}>
                <span className="font-bold text-slate-800 text-sm leading-tight">{report.title}</span>
                <br />
                <span className="text-sm text-[#b6c3d1] font-semibold tracking-wide">{report.time}</span>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </div>
    </div>
  );
} 